import { Button } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useInvoiceStatusActions } from '@features/invoices/hooks/useInvoiceStatusActions'

import { useInvoice } from '../../../../contexts/invoiceContext'
import { useTrackInvoiceView } from '../../../../hooks/useTrackInvoiceView'

export const UnmarkInvoiceAsSentButton = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoiceView } = useTrackInvoiceView()
  const { documentType, invoiceId } = useInvoice()

  const { unmarkInvoiceAsSent, isProcessing } = useInvoiceStatusActions({ documentType, invoiceId })

  const handleClick = useCallback(() => {
    trackInvoiceView('Unmark as sent action clicked')
    unmarkInvoiceAsSent()
  }, [unmarkInvoiceAsSent, trackInvoiceView])

  return (
    <Button icon="paperPlane" loading={isProcessing} onClick={handleClick} variant="outlined">
      {t('external_invoices.view.unmark_as_sent')}
    </Button>
  )
}
